const lightTheme = {
  colors: {
    primary: "#6B8E23",
    primaryHover: "#556B1A",
    primaryLight: "#E8F0DC",
    secondary: "#64748B",
    secondaryHover: "#475569",
    accent: "#F59E0B",
    accentHover: "#D97706",

    text: {
      primary: "#0F172A",
      secondary: "#475569",
      tertiary: "#94A3B8",
      inverse: "#FFFFFF",
    },

    background: {
      primary: "#FFFFFF",
      secondary: "#F8FAFC",
      tertiary: "#F1F5F9",
      dark: "#0F172A",
    },

    border: {
      light: "#E2E8F0",
      medium: "#CBD5E1",
      dark: "#64748B",
    },

    success: "#10B981",
    warning: "#F59E0B",
    error: "#EF4444",
    info: "#3B82F6",
  },
};

const darkTheme = {
  colors: {
    primary: "#8FAE3F",
    primaryHover: "#6B8E23",
    primaryLight: "#3A4A17",
    secondary: "#94A3B8",
    secondaryHover: "#CBD5E1",
    accent: "#FBBF24",
    accentHover: "#F59E0B",

    text: {
      primary: "#F1F5F9",
      secondary: "#CBD5E1",
      tertiary: "#94A3B8",
      inverse: "#0F172A",
    },

    background: {
      primary: "#101010",
      secondary: "#1e1e1e",
      tertiary: "#334155",
      dark: "#101010",
    },

    border: {
      light: "#334155",
      medium: "#475569",
      dark: "#64748B",
    },

    success: "#34D399",
    warning: "#FBBF24",
    error: "#F87171",
    info: "#60A5FA",
  },
};

const baseTheme = {
  typography: {
    h1: "clamp(2.5rem, 5vw, 4rem)",
    h2: "clamp(2rem, 4vw, 3rem)",
    h3: "clamp(1.5rem, 3vw, 2.25rem)",
    h4: "clamp(1.25rem, 2.5vw, 1.875rem)",
    h5: "clamp(1.125rem, 2vw, 1.5rem)",
    h6: "clamp(1rem, 1.5vw, 1.25rem)",
    body: "1rem",
    small: "0.875rem",
    xs: "0.75rem",
  },

  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
    "2xl": "3rem",
    "3xl": "4rem",
    "4xl": "5rem",
    "5xl": "6rem",
    section: "5rem",
  },

  borderRadius: {
    none: "0",
    sm: "0.125rem",
    base: "0.25rem",
    md: "0.375rem",
    lg: "0.5rem",
    xl: "0.75rem",
    "2xl": "1rem",
    "3xl": "1.5rem",
    full: "9999px",
  },

  shadows: {
    sm: "0 1px 2px 0 rgb(0 0 0 / 0.05)",
    base: "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
    md: "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
    lg: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
    xl: "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
    "2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
  },

  breakpoints: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
  },

  zIndex: {
    hide: -1,
    auto: "auto",
    base: 0,
    docked: 10,
    dropdown: 1000,
    sticky: 1100,
    banner: 1200,
    overlay: 1300,
    modal: 1400,
    popover: 1500,
    skipLink: 1600,
    toast: 1700,
    tooltip: 1800,
  },

  transitions: {
    fast: "150ms ease",
    base: "250ms ease",
    slow: "350ms ease",
  },
};

export const getTheme = (mode = "light") => ({
  ...baseTheme,
  ...(mode === "dark" ? darkTheme : lightTheme),
});

export const theme = getTheme("light");
export { lightTheme, darkTheme };
